import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)


const routes = [
    {
        path: '/',
        name: 'home',
        component: Home,
        meta: {title: '首页'}
    },
    {
        path: '/solution',
        name: 'solution',
        component: () => import('./views/Solution.vue'),
        meta: {title: '解决方案'}
    },
    {
        path: '/case',
        name: 'case',
        component: () => import('./views/Case2.vue'),
        meta: {title: '经典案例'}
    },
    {
        path: '/partner',
        name: 'partner',
        component: () => import('./views/Partner2.vue'),
        meta: {title: '产品介绍'}
    },
    {
        path: '/about-us',
        name: 'about-us',
        component: () => import('./views/About-us.vue'),
        meta: {title: '关于我们'}
    }

]

const router = new Router({routes})

router.beforeEach((to, from, next) => {
    document.title = `中科德诺-${to.meta.title}`
    next()
})

export {
    routes
}

export default router


